module.exports = __webpack_public_path__ + "static/loading-cac6f4f6ddbe92403ef75aab346d1f59.gif";